import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

const getDateFormat = date => moment(date).format('DD.MM.YYYY');

export default function DateCell({ dates }) {
  const { daily, deadlineDay, certainDays, createDay, completionDay } = dates;

  return (
    <>
      <p>
        <FormattedMessage id="CREATED" /> {getDateFormat(createDay)}
      </p>
      {daily ? (
        <p>
          <FormattedMessage id="daily_over" defaultMessage="" />{' '}
          {getDateFormat(deadlineDay)}
        </p>
      ) : (
        deadlineDay && (
          <p>
            <FormattedMessage id="COMPLETE_OVER" defaultMessage="" />{' '}
            {getDateFormat(deadlineDay)}
          </p>
        )
      )}
      {certainDays?.length > 0 && (
        <p>
          <FormattedMessage id="BY_DAYS" defaultMessage="" />{' '}
          {certainDays.map(el => getDateFormat(el)).join(', ')}
        </p>
      )}

      {completionDay && (
        <p>
          <FormattedMessage id="COMPLETED" /> {getDateFormat(completionDay)}
        </p>
      )}
    </>
  );
}

DateCell.propTypes = {
  dates: PropTypes.object.isRequired,
};
